// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul[data-v-5027b260]:not(.nav-pills) {
  list-style: none;
}
li[data-v-5027b260]:not(.nav-item) {
  font-weight: lighter;
  font-size: 0.8em;
}
li[data-v-5027b260]:not(.nav-item):before {
  content: "\\f054";
  /* FontAwesome Unicode fa-chevron-right*/
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  display: inline-block;
  margin-left: -1.3em;
  /* same as padding-left set on li */
  width: 1.3em;
  /* same as padding-left set on li */
}
img[data-v-5027b260] {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  height: auto;
}
.avatar-small[data-v-5027b260] {
  width: 100px;
  border-radius: 6px;
  display: block;
  padding: 2px;
  margin: 10px auto;
}
/*.avatar-small:hover {*/
/*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
/*    -ms-transform: scale(2.5); !* IE 9 *!*/
/*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
/*    transform: scale(2.5);*/
/*    cursor: pointer;*/
/*    z-index: 99999;*/
/*}*/
.card-header .badge[data-v-5027b260] {
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/application/equipment_pricing/view_equipments.vue","webpack://./view_equipments.vue"],"names":[],"mappings":"AACI;EACI,gBAAA;ACAR;ADGI;EACI,oBAAA;EACA,gBAAA;ACDR;ADII;EACI,gBAAA;ECFN,wCAAwC;EDGlC,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;ECDN,mCAAmC;EDE7B,YAAA;ECAN,mCAAmC;AACrC;ADEI;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;ACAR;ADGI;EACI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;ACDR;AACA,wBAAwB;AACxB,qDAAqD;AACrD,4CAA4C;AAC5C,sDAAsD;AACtD,6BAA6B;AAC7B,uBAAuB;AACvB,sBAAsB;AACtB,IAAI;ADKA;EACI,YAAA;ACHR","sourcesContent":["\n    ul:not(.nav-pills) {\n        list-style: none;\n    }\n\n    li:not(.nav-item) {\n        font-weight: lighter;\n        font-size: 0.8em;\n    }\n\n    li:not(.nav-item):before {\n        content: \"\\f054\"; /* FontAwesome Unicode fa-chevron-right*/\n        font-family: 'Font Awesome 5 Free';\n        font-weight: 900;\n        display: inline-block;\n        margin-left: -1.3em; /* same as padding-left set on li */\n        width: 1.3em; /* same as padding-left set on li */\n    }\n\n    img {\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n        max-width: 100%;\n        height: auto\n    }\n\n    .avatar-small {\n        width: 100px;\n        border-radius: 6px;\n        display: block;\n        padding: 2px;\n        margin: 10px auto;\n    }\n\n    /*.avatar-small:hover {*/\n    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/\n    /*    -ms-transform: scale(2.5); !* IE 9 *!*/\n    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/\n    /*    transform: scale(2.5);*/\n    /*    cursor: pointer;*/\n    /*    z-index: 99999;*/\n    /*}*/\n\n    .card-header .badge {\n        float: right;\n    }\n\n","ul:not(.nav-pills) {\n  list-style: none;\n}\nli:not(.nav-item) {\n  font-weight: lighter;\n  font-size: 0.8em;\n}\nli:not(.nav-item):before {\n  content: \"\\f054\";\n  /* FontAwesome Unicode fa-chevron-right*/\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 900;\n  display: inline-block;\n  margin-left: -1.3em;\n  /* same as padding-left set on li */\n  width: 1.3em;\n  /* same as padding-left set on li */\n}\nimg {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n  height: auto;\n}\n.avatar-small {\n  width: 100px;\n  border-radius: 6px;\n  display: block;\n  padding: 2px;\n  margin: 10px auto;\n}\n/*.avatar-small:hover {*/\n/*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/\n/*    -ms-transform: scale(2.5); !* IE 9 *!*/\n/*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/\n/*    transform: scale(2.5);*/\n/*    cursor: pointer;*/\n/*    z-index: 99999;*/\n/*}*/\n.card-header .badge {\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
